import type { Channel } from 'phoenix'

export const leaveChannelWithTimeout = async (
  channel: Channel | undefined, 
  timeoutMs = 3000
): Promise<void> => {
  if (!channel) {
    return
  }

  try {
    await Promise.race([
      new Promise<void>((resolve) => {
        channel.leave().receive('ok', () => { resolve() })
      }),
      new Promise<void>((resolve) => {
        setTimeout(() => {
          resolve()
        }, timeoutMs)
      })
    ])
  } catch (error) {
    console.warn('[CHANNEL] Error during leave operation, continuing:', error)
  }
}